/*
 * @Description: 收房合同维护
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2022-02-14 23:25:48
 * @LastEditors: zhao - 🍉
 */

import React from 'react';
import {Divider, message} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';

import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config } from '../../axios';
import {commonIsMap, dicClarifyStatus, dicRecvCertType} from '../../axios/dictionaries';
import AcceptHousingContractAdd from './components/AcceptHousingContractAdd';
import { isPlatform } from '../../utils';
import AuthTable from '../../components/AuthTable';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                pageSize: 10,
                recvCertType:'',
                housingContract:1,
                recvKeyword:'',
                merchantKeyword:'',
                clarify:''
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_building_findBuildingPageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true })
        this.buildingAddRef.loadPack({ id })
    }

    handleRentCycle = (id) => {
        this.props.history.push('/admin/merchant/rentCycle?buildingId=' + id)
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }



    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        let _column = columns({ handleEdit: this.handleEdit, handleRentCycle: this.handleRentCycle, handleRemove: this.handleRemove,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })


        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list" />
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <AuthTable actionKeyList={['z-2-1']}>
                    <TableDOM
                        columns={_column}
                        data={tableData}
                        loading={tableLoading}
                        total={tableTotal}
                        current={current}
                        onChange={this.handleSearch}
                        scroll={{x: 1500}}
                    />
                </AuthTable>
                <AcceptHousingContractAdd
                    onRef={ref => this.buildingAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
            </PageWrap>
        )
    }


}

const searchData = () => {

    let data =[
        {
            tagName: 'Select',
            formConfig: { name: 'clarify' },
            attribute: { placeholder: '是否清算', style: { width: '160px' } },
            optionData: [{ title: '全部', value: '' }].concat(commonIsMap),
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'merchantReconciliation' },
            attribute: { placeholder: '是否参与商户对账', style: { width: '160px' } },
            optionData: [{ title: '全部', value: '' }].concat(commonIsMap),
            notResult: '',
        },
        {
            tagName: 'Select',
            formConfig: { name: 'recvCertType' },
            attribute: { placeholder: '证件类型', style: { width: '220px' } },
            optionData: [{ title: '全部', value: '' }].concat(dicRecvCertType),
            notResult: '',
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'recvKeyword' },
            attribute: { placeholder: '输入业主名称或证件号码', style: { width: '160px' } },
            title: `在业主名称或证件号码内模糊查询`
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'merchantKeyword' },
            attribute: { placeholder: '输入商户名称', style: { width: '160px' } },
            title: `在商户名称或商户简称内模糊查询`
        },
        {
            tagName: 'InputTip',
            formConfig: { name: 'keyword' },
            attribute: { placeholder: '输入关键字', style: { width: '160px' } },
            title: `在小区/楼栋内模糊查询`
        },
    ];

    data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'merchantName') {
            return false;
        }
        return true;
    });

    return data;

};
const columns = ({ handleEdit, handleRentCycle}) => [
    {
        title: '小区/楼栋名称',
        dataIndex: 'name'
        , width:200
    },
    {
        title: '小区/楼栋编号',
        dataIndex: 'buildingNo'
        , width:150
    },
    {
        title: '业主名称',
        dataIndex: 'recvName'
    },
    {
        title: '业主证件类型',
        dataIndex: 'recvCertType',
        width:200,
        render(text, record, index) {
            let now = dicRecvCertType.find(item => item.value === text);
            if (now)
                return <span>{now.title}</span>;
            return null
        }
    },
    {
        title: '业主证件号码',
        dataIndex: 'recvCertNo'
    },
    {
        title: '承租月租金',
        dataIndex: 'payAmtByMonth'
    },
    {
        title: '承租押金',
        dataIndex: 'depositAmt'
    },
    {
        title: '是否清算',
        dataIndex: 'clarify',
        render(text, record, index) {
            let now = dicClarifyStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '是否参与商户对账',
        dataIndex: 'merchantReconciliation',
        render(text, record, index) {
            let now = dicClarifyStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 150,
        fixed: 'right',
        render(text, record, index) {
            return <span>
                <AuthButton authkey="z-2-1">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                      <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="z-2-2">
                    <span className="showClickDetail" onClick={() => { handleRentCycle(record.id) }}>房租周期</span>
                </AuthButton>

            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/RentContract/AcceptsHousingContract.js